export const getLinkSplitConfigsQuery = ({ link_pagamento_id, page }) => ({
  url: `/link-split-config`,
  method: "get",
  params: { link_pagamento_id, page },
});
